import {FileUploadControl, FileUploadControlCallback} from "../common/FileUploadControl";
import React, {useRef} from "react";
import {Button} from "@mui/material";
import {StackPanel} from "../panels/StackPanel";
import {pgpReadKey} from "../../util/PGPUtil";
import {useAppDispatch, useAppStore} from "../../hooks/ReduxHooks";
import {SystemActions} from "../../actions/SystemActions";
import {ItemActions} from "../../actions/ItemActions";
import {pgpKeyFromRawKey} from "../../domain/PgpKey";
import KeyIcon from '@mui/icons-material/Key';

export const PgpKeyListControlsView = () => {
    const dispatch = useAppDispatch();

    const store = useAppStore();

    async function attachmentFilesSelected(files: FileList) {

        console.log("File: ", files);

        const allKeys = store.getState().accountsState.pgpKeys;

        for (let i = 0; i < files.length; i++) {
            const file: File = files[i];

            const reader = new FileReader();
            reader.addEventListener('load', (e) => {
                const text = e.target?.result?.toString() || "";
                pgpReadKey({armoredKey: text})
                    .then(key => pgpKeyFromRawKey(key, allKeys).then(enrichedKey => dispatch(ItemActions.showItemContent(enrichedKey))),
                        error => dispatch(SystemActions.showError("Unable to import key: " + error.message)));
            });
            reader.readAsText(file);
        }
    }
    
    const fileControlRef = useRef<FileUploadControlCallback>();

    const showImportKeyDialog = () => fileControlRef.current?.openFileDialog();
    
    return (
        <StackPanel orientation="horizontal"
                    className="panel">
            <FileUploadControl fileControlRef={fileControlRef} onFilesSelected={attachmentFilesSelected}/>
            
            <Button variant="contained" 
                    onClick={showImportKeyDialog}>
                <KeyIcon/>&nbsp;Load Key
            </Button>
        </StackPanel>
    );    
}